<template>
  <div class="bgBox">
    <div class="headerBox">
      <HearderPage title="长护险服务运营平台" />
    </div>
    <div class="contentBoxwxF">
      <div class="divLone">
        <div class="boxTitlebox">
          <div class="img"></div>
          <div class="text">护理团队</div>
        </div>
        <div class="boxContainer boxTopDown">
          <div class="divLoneDivOne">
            <div class="model12" v-for="(item, index) in lOneData" :key="index">
              <img class="img" :src="item.img" alt="image" />
              <div class="info">
                <div class="infoUp">
                  {{ item.number1 }}<span>&nbsp;&nbsp;{{ item.number2 }}</span>
                </div>
                <div class="infoDown">{{ item.name }}</div>
              </div>
            </div>
          </div>

          <div class="divLoneDivTwo">
            <div class="title">男女比例</div>
            <div class="leftThDownItembox">
              <div class="leftThDownItemLw">
                <div class="leftThDownItemL"></div>
                <div class="leftThDownItemValueL">64%</div>
              </div>
              <div class="leftThDownItemRw">
                <div class="leftThDownItemR"></div>
                <div class="leftThDownItemValueR">36%</div>
              </div>
            </div>
          </div>
          <div class="divLoneDivTh">
            <div class="title">持证率</div>
            <div class="divLoneDivThChart">
              <!-- <CircularCircularDiagramPie :list="CircularList" /> -->
              <CircularPieAddBG />
            </div>
          </div>
        </div>
      </div>

      <div class="divLTwo">
        <div class="boxTitlebox">
          <div class="img"></div>
          <div class="text">服务数据统计</div>
        </div>

        <div class="boxContainer">
          <Line3Charts :list="line3ChartsList" />
        </div>
      </div>

      <div class="divLTh">
        <div class="boxTitlebox">
          <div class="img"></div>
          <div class="text">客户满意度</div>
        </div>
        <div class="boxContainer boxTopDown">
          <vue3-seamless-scroll
            hover-stop="true"
            :list="divLThLInfoList"
            :hover="true"
            :step="0.5"
          >
            <div
              style="
                width: 100%;
                height: 100%;
                position: relative;
                display: flex;
                margin-bottom: 20px;
              "
              v-for="(item, index) in divLThLInfoList"
              :key="index"
            >
              <div class="divLThL">
                <h4>{{ item.title }}</h4>
                <img :src="item.img" />
                <h5>{{ item.talent }}</h5>
              </div>
              <div class="divLThR">
                <p>{{ item.info }}</p>
                <div>—— {{ item.name }}</div>
              </div>
            </div>
          </vue3-seamless-scroll>
        </div>
      </div>

      <!-- <div class="divCOneinfoText">
        <div class="iCon"></div>
         <div class="infoList"> 
        <marquee behavior="srcoll" class="infoList">
          简介:这是这个项目的详细介绍,文字很长,自动滚动显示.
        </marquee>
         </div>  
      </div> -->

      <div class="divCOneinfo">
        <div
          class="divCOneinfoItem"
          v-for="(item, index) in divCOneinfolist"
          :key="index"
        >
          <div class="infoBox">
            <div class="box">
              <div class="name">{{ item.name }}</div>
              <div class="value">
                {{ currentValues[index] }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="divCTweMap">
        <div class="map2" id="map_1">
          <!-- <ChinaMap2 /> -->
          <ChinaMap v-if="mapflag == 1" @setMapInfo="getMapInfo" />
          <Map
            v-if="mapflag == 2"
            @setMapInfo2="getMapInfo2"
            :mapflagaddress="mapflagaddress"
          />
        </div>
      </div>

      <div class="divCTh">
        <div class="boxTitlebox">
          <div class="img"></div>
          <div class="text">服务对象分析</div>
        </div>
        <div class="boxContainer boxTopDown" style="display: flex">
          <div class="divCThLeftDiv">
            <div class="title">对象分析</div>
            <div class="divCTwoinfo">
              <div
                class="divCTwoinfoItem"
                v-for="(item, index) in divCTwoinfolist"
                :key="index"
              >
                <div :class="['value' + index]">{{ item.value }}</div>
                <div class="name">{{ item.name }}</div>
              </div>
            </div>

            <div class="divCTwoCharts">
              <div
                class="divCTwoChartsitem"
                v-for="(item, index) in pielist"
                :key="index"
              >
                <div class="name">{{ item.name }}</div>
                <pie :list="item" />
              </div>
            </div>
          </div>

          <div class="divCThRightDiv">
            <div class="title">不同年龄段数据分析</div>
            <div class="chartsdiv">
              <Bar3Line1Charts :list="bar3Line1ChartsList" />
            </div>
          </div>
        </div>
      </div>

      <div class="divRone">
        <div class="boxTitlebox">
          <div class="img"></div>
          <div class="text">工单稽核</div>
        </div>
        <div class="boxContainer boxTopDown">
          <div
            style="
              margin-top: 15px;
              display: flex;
              justify-content: space-around;
            "
          >
            <div class="model12" v-for="(item, index) in ROneData" :key="index">
              <img class="img" :src="item.img" alt="image" />
              <div class="info">
                <div class="infoUp">
                  {{ item.number1 }}<span>&nbsp;&nbsp;{{ item.number2 }}</span>
                </div>
                <div class="infoDown">{{ item.name }}</div>
              </div>
            </div>
          </div>
          <TableM
            :list="momentDiligenceSortList"
            :onChangeAnalysisFlag="onChangeAnalysisFlag"
          />
        </div>
      </div>

      <div class="divRTwo">
        <div class="boxTitlebox">
          <div class="boxTitlebox">
            <div class="img"></div>
            <div class="text">实时服务工单</div>
          </div>
        </div>
        <div class="boxContainer boxTopDown">
          <div
            class="containerTop"
            style="
              margin-top: 15px;
              display: flex;
              justify-content: space-around;
            "
          >
            <div class="containerTopbox">
              <vue3-seamless-scroll
                hover-stop="true"
                :list="RtwoItemList"
                :hover="true"
                :step="0.8"
              >
                <div
                  class="RtwoItemdiv"
                  v-for="(item, index) in RtwoItemList"
                  :key="index"
                >
                  <div class="textName">{{ item.name }}</div>
                  <div class="divW">
                    <span class="time">{{ item.time }}</span>
                    <span class="address">{{ item.address }}</span>
                  </div>
                  <div class="button" @click="RtwoItembutton(item.info)"></div>
                </div>
              </vue3-seamless-scroll>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <el-dialog v-model="dialogVisible" title="详情" :before-close="handleClose">
    <span>{{ dialogVisibleInfo }} </span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import "./style.less";
import router from "@/router";
import request from "../../utils/request";
import HearderPage from "@/components/hearderPage.vue";
import CircularCircularDiagramPie from "./components/CircularCircularDiagramPie.vue";
import CircularPieAddBG from "./components/CircularPieAddBG.vue";
import Pie from "./components/Pie.vue";
import Line3Charts from "./components/line3Charts.vue";
import Bar3Line1Charts from "./components/bar3D1Line1Charts.vue";
import TableM from "./components/tableM.vue";
import Map from "./components/map.vue";
import ChinaMap from "./components/chinaMap.vue";
import ChinaMap2 from "./components/chinaMap2.vue";

export default {
  name: "home",
  components: {
    HearderPage,
    CircularCircularDiagramPie,
    TableM,
    CircularPieAddBG,
    Line3Charts,
    Bar3Line1Charts,
    Pie,
    Map,
    ChinaMap,
    ChinaMap2,
  },
  data() {
    return {
      flag: 1,
      mapflag: 1,
      mapflagaddress: "",

      dialogVisible: false,
      dialogVisibleInfo: "",
      lOneData: [
        {
          id: 1,
          name: "护理人员数量",
          number1: "69",
          number2: "个",
          img: require("./assets/lOneModel1.png"),
        },
        {
          id: 2,
          name: "人均服务工单",
          number1: "65",
          number2: "次",
          img: require("./assets/lOneModel2.png"),
        },
      ],
      /* l2 */
      line3ChartsList: {
        xData: [
          [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ],
          ["服务数"],
        ],
        yData: [[5, 7, 8, 8, 6, 75, 45, 8, 8, 6, 7, 9]],
      },

      divLThLInfoList: [
        {
          title: "金牌护理员：王亚丫",
          img: require("./assets/peopleimg.png"),
          talent: "擅长：按摩、理疗、助浴",
          info: "服务认真，专业，对待老人耐心，感谢培养这么优秀的护理员。",
          name: "王某某家属",
        },
        {
          title: "金牌护理员：王亚丫1",
          img: require("./assets/peopleimg.png"),
          talent: "擅长：按摩、理疗、助浴",
          info: "服务认真，专业，对待老人耐心，感谢培养这么优秀的护理员。",
          name: "王某某家属",
        },
        {
          title: "金牌护理员：王亚丫2",
          img: require("./assets/peopleimg.png"),
          talent: "擅长：按摩、理疗、助浴",
          info: "服务认真，专业，对待老人耐心，感谢培养这么优秀的护理员。",
          name: "王某某家属",
        },
        {
          title: "金牌护理员：王亚丫3",
          img: require("./assets/peopleimg.png"),
          talent: "擅长：按摩、理疗、助浴",
          info: "服务认真，专业，对待老人耐心，感谢培养这么优秀的护理员。",
          name: "王某某家属",
        },
      ],

      /* 中间开始 */
      divCOneinfolist: [
        { name: "服务总次数", value: 18865 },
        { name: "今日服务人数", value: 18865 },
        { name: "服务总人数", value: 18865 },
      ],

      currentValues: [], // 用于存储每个item的当前值
      intervals: [], // 用于存储每个item的定时器

      divCTwoinfolist: [
        { name: "重度失能Ⅰ级", value: "10.23%" },
        { name: "重度失能Ⅱ级", value: "40.98%" },
        { name: "重度失能Ⅲ级", value: "27.60%" },
      ],

      pielist: [
        { color: "#00FDA8", name: "男生比例", value: 80 },
        { color: "#EFC342", name: "女生比例", value: 80 },
      ],

      bar3Line1ChartsList: {
        xData: [
          ["60-70岁", "70-80岁  ", "80-90岁", "90-100岁", "100岁以上"],
          ["通话"],
        ],
        yData: [[150, 126, 260, 220, 184]],
      },

      /* 右开始 */
      ROneData: [
        {
          id: 1,
          name: "本日稽核工单",
          number1: "49",
          number2: "次",
          img: require("./assets/lOneModel1.png"),
        },
        {
          id: 2,
          name: "工单稽核率",
          number1: "65%",
          number2: "",
          img: require("./assets/lOneModel2.png"),
        },
      ],
      momentDiligenceSortList: [
        {
          id: 1,
          name: "张三",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          audioUrl: require("./assets/夜曲.mp3"),
          isPlaying: false, // 新增：记录音频播放状态
        },
        {
          id: 2,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "1",
          audioUrl: require("./assets/韩可可.mp3"),
          isPlaying: false, // 新增：记录音频播放状态
        },
        {
          id: 3,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "2",
          audioUrl: require("./assets/黄霄雲.mp3"),
          isPlaying: false, // 新增：记录音频播放状态
        },
        {
          id: 4,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          audioUrl: require("./assets/刘惜君.mp3"),
          isPlaying: false, // 新增：记录音频播放状态
        },
        {
          id: 5,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          audioUrl: require("./assets/偏爱.mp3"),
          isPlaying: false, // 新增：记录音频播放状态
        },
        {
          id: 6,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          audioUrl: require("./assets/夜曲.mp3"),
          isPlaying: false, // 新增：记录音频播放状态
        },
        {
          id: 7,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          audioUrl: require("./assets/夜曲.mp3"),
          isPlaying: false, // 新增：记录音频播放状态
        },
        {
          id: 8,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          audioUrl: require("./assets/夜曲.mp3"),
          isPlaying: false, // 新增：记录音频播放状态
        },
        {
          id: 9,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          audioUrl: require("./assets/夜曲.mp3"),
          isPlaying: false, // 新增：记录音频播放状态
        },
        {
          id: 10,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          audioUrl: require("./assets/夜曲.mp3"),
        },
        {
          id: 11,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          audioUrl: require("./assets/夜曲.mp3"),
          isPlaying: false, // 新增：记录音频播放状态
        },
        {
          id: 12,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          audioUrl: require("./assets/夜曲.mp3"),
          isPlaying: false, // 新增：记录音频播放状态
        },
        {
          id: 13,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          audioUrl: require("./assets/夜曲.mp3"),
          isPlaying: false, // 新增：记录音频播放状态
        },
        {
          id: 14,
          name: "王甜",
          number1: "03-04 9:00",
          number2: "电话回访",
          number3: "0",
          audioUrl: require("./assets/夜曲.mp3"),
          isPlaying: false, // 新增：记录音频播放状态
        },
      ],

      CircularList: [
        { name: "类型1", value: 754 },
        { name: "类型2", value: 611 },
        { name: "类型3", value: 400 },
        { name: "类型4", value: 200 },
      ],

      RtwoItemList: [
        {
          name: "张三正在服务护理张大爷",
          time: "2025年2月23日 ",
          address: "某某地区某某街道",
          info: "详情信息",
        },
        {
          name: "张三正在服务护理张大爷",
          time: "2025年2月23日 ",
          address: "某某地区某某街道",
          info: "详情信息",
        },
        {
          name: "张三正在服务护理张大爷",
          time: "2025年2月23日 ",
          address: "某某地区某某街道",
          info: "详情信息",
        },
        {
          name: "张三正在服务护理张大爷",
          time: "2025年2月23日 ",
          address: "某某地区某某街道",
          info: "详情信息",
        },
        {
          name: "张三正在服务护理张大爷",
          time: "2025年2月23日 ",
          address: "某某地区某某街道",
          info: "详情信息",
        },
      ],

      lossFriendTrendStatsLis: [
        { name: "毛尖占比", value: 10 },
        { name: "采摘地块", value: 15 },
        { name: "毛峰占比", value: 20 },
        { name: "毛峰占比", value: 2 },
      ],
    };
  },
  watch: {
    // nowTime: {
    //   handler(newVal, oldVal) {
    //     this.downThBoxShow = false
    //     if (true) { this.$nextTick(() => { this.downThBoxShow = true }) }
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  computed: {
    // msg() {
    //   //  从vuex 的 state 文件中获取值
    //   return this.$store.state.resName;
    //   // this.$router.push()...
    //   // this.$root
    // }
  },

  mounted() {
    this.initCounters();
  },
  beforeDestroy() {
    this.clearIntervals();
  },
  methods: {
    initCounters() {
      this.divCOneinfolist.forEach((item, index) => {
        this.currentValues[index] = 0; // 初始化当前值为0
        this.intervals[index] = setInterval(() => {
          if (this.currentValues[index] < item.value) {
            this.currentValues[index] = this.currentValues[index] + 10; // 每次增加10，可以根据需要调整;
          } else {
            clearInterval(this.intervals[index]); // 如果达到目标值，则清除定时器
          }
        }, 1); // 每10毫秒增加1，可以根据需要调整
      });
    },
    clearIntervals() {
      this.intervals.forEach((interval) => {
        clearInterval(interval);
      });
    },

    getMapInfo(info) {
      this.mapflag = 2;
      this.mapflagaddress = info;
      console.log(info);
    },
    getMapInfo2() {
      this.mapflag = 1;
    },

    onChangeAnalysisFlag() {
      // You can add your logic here
    },

    handleClose() {},

    RtwoItembutton(e) {
      this.dialogVisibleInfo = e;
      this.dialogVisible = true;
      // router.push({
      //   path: "/home/orderDetails",
      // });
    },
  },
};
</script>

<style scoped></style>
